// extracted by mini-css-extract-plugin
export var completionBody = "_kv-2";
export var completionCard = "_kv-0";
export var completionFooter = "_kv-3";
export var completionTitle = "_kv-1";